import { Box } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useJobApplicants } from './job-applicants-provider';

function JobApplicantsAppliedInfoView() {
   const { t } = useTranslation('global');
   const jobApplicants = useJobApplicants();
   return (
      <Box className="JobseekersContentTop">
         <ul>
            <li>
               <h4>{jobApplicants.jobSeekers?.totalCandidate}</h4>
               <h6>{t('employerInnerAccountdetail.total')}</h6>
            </li>
            <li>
               <h4>{jobApplicants.jobSeekers?.new}</h4>
               <h6>{t('employerInnerAccountdetail.new')}</h6>
            </li>
            <li>
               <h4>{jobApplicants.jobSeekers?.reviewed}</h4>
               <h6>{t('employerInnerAccountdetail.reviewed')}</h6>
            </li>
            <li>
               <h4>{jobApplicants.jobSeekers?.shortList}</h4>
               <h6>{t('employerInnerAccountdetail.shortlist')}</h6>
            </li>
            <li>
               <h4>{jobApplicants.jobSeekers?.interview}</h4>
               <h6>{t('employerInnerAccountdetail.interview')}</h6>
            </li>
            <li>
               <h4>{jobApplicants.jobSeekers?.offer}</h4>
               <h6>{t('employerInnerAccountdetail.offer')}</h6>
            </li>
            <li>
               <h4>{jobApplicants.jobSeekers?.accept}</h4>
               <h6>{t('employerInnerAccountdetail.accept')}</h6>
            </li>
            <li>
               <h4>{jobApplicants.jobSeekers?.notSuitable}</h4>
               <h6>{t('employerInnerAccountdetail.notSuitable')}</h6>
            </li>
         </ul>
      </Box>
   );
}

export const JobApplicantsAppliedInfo = observer(JobApplicantsAppliedInfoView);
